module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_TechGeek-8430a720aec79de04471f7808d90fd0f.jpg";